/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-26 17:18:42
 * @Description:
 */
import { sSiteName } from '@/utils/constant';

// ▼首页标题
const gameTitle = {
    Hot:'热门',
    New:'新游',
    Test: '内测游戏',
    Playing:'在玩',
    OnlineUsers:'在线人数',
    JackpotAmount:'Jackpot 金额',
    FrequentlyPlaying: '常玩游戏',
    PopularGames: '热门游戏',
}

// ▼控制游戏下注等
const gameControl = {
    Manaual: '手动',
    Auto: '自动',
    AutoDialogTitle: '自动投注策略设置', // Automatic betting rule settings
    Strategies: '策略',
    Min: '最小',
    Max: '最大',
    BetAmount: '投注金额',
    Amount: '数量',
    CashoutAt: '止盈于',
    Bets: '投注',
    MinBet: '最小投注',
    MaxBet: '最大投注',
    Bet: '投注', 
    StartPlaying: '开始游戏',
    BetStart: '开始',
    BetStop: '停止',
    customAmount: '自定义',
    ...{
        // 以下内容用于自动模式的输入面板（弹窗）中
        NUMBER_OF_BETS: '投注次数',
        STOP_ON_PROFIT: '止盈金额',
        STOP_ON_LOSS: '止损金额',
        MAX_BET_AMOUNT: '最大投注金额',
        ON_WIN: '赢时',
        ON_LOSS: '输时',
        Reset: '重置',
        Increase: '加注',
    },
    ...{
        // 与上面内容重复，用处不明 
        MaxBetAmount: '最大下注金额',
        StopOnLoss: '亏损停止',
        NumberOfBets: '下注次数',
        StopOnProfit: '盈利停止',
        OnWin: '赢时',
        OnLoss: '输时',
    },
};


// 👇 用于菜单与按钮（先放在此类，逐步优化）
const menuAndBtn = {
    rank: '等级',
    wallet: '钱包',
    unableChange: '自动游戏时无法变更货币',
    version: '版本信息',
};

// ▼历史记录
const history = {
    USER: '用户',
    deposit: '转入',
    withdraw: '转出',
    inAndOut: '全部',
};

const ShareBtn = {
    Share: '分享',
    ShareTitle: `做得好！在社交网络上与朋友分享这个。在 ${sSiteName} 上玩更多，获得新的成就。`,
    Section1: '本次投注不参与分享 & 赢取奖励。',
    AboutShareAndWin: '关于分享 & 赢取',
    Message: '讯息',
    Section2: `Hey guys！我想分享这个赢取到你。我很高兴赢得它在 ${sSiteName} 上。`,
    BetCorgiChat: `${sSiteName} 聊天`,
    Twitter: 'Twitter',
    Telegram: 'Telegram',
    MyWin: '胜利',
    MyWinTextIcon: '胜利 🎉',
};

// ▼游戏 SpaceDice 相关
const GameSpaceDice = {
    SpaceDiceRule1: '通过移动滑块选择一个数值范围并下注，如果生成的幸运数字落在该范围内即为赢。',
    ChooseNumber: '选择数字',
    Low: '低',
    High: '高',
};

// ▼游戏 Dice 相关
const GameDice = {
    'ruleText': '通过移动滑块选择一个预测值并下注，如果生成的幸运数字小于预测值即为赢。',
    Prediction: '预测',
    LuckyNumber: '幸运数字',
};

const GameRing = {
    Segments: '段',
    ringRule1: '选择风险级别并下注，如果指针停在相应倍数区域即可赢得相应倍数的奖金。',
};

const GameCryptos = {
    CryptosRule1: '五种货币中，出现相同货币的数量越多，赔率越高。',
};

const GameTower = {
    AutoPick: '自动选择',
    Cleartable: '清除已选',
    Rule1: '选择恶魔数量并下注，从下往上点开格子，避开恶魔以赢得万倍奖金。',
    Devilkins: '恶魔数量',
    DevilkinsNums: '恶魔数量',
};

const GameStairs = {
    Rule1: '选择掉落的石头数量并下注，爬梯避开石头，爬得越高奖励越高。',
};

const GameBlackJack = {
    PerfectPairs: '完美对子',
    TotalBet: '总下注',
    Hit: '要牌',
    Stand: '停牌',
    Split: '拆分',
    Double: '加倍',
    Insurance: '如果庄家有天然 21 点，我同意下半注的保险注，保险赔率为2:1。',
    SidebetWin: '边投赢',
    SideBetInfo: '边注详情',
    PerfectPair: '完美对子',
    ProMode: '更多玩法', // Pro Mode 
    handCard: '手牌',
    betsList: '押注清单',
    anteBet: '底注',
    insuranceItem: '保险', 
    cannotChange: '游戏进行中不可切换', 
    ruleText: `
        1. 仅在庄家亮的第一张牌为 A 时，才适用此作为保险的边注选项。
        2. 若玩家和庄家皆于前两张牌获得 21 点则结果是平局。
        3. 若庄家的首两张牌合计为 21 点，则游戏结束，并将赔付有保险的玩家。
        4. 21 点赔率为 x2.5，保险赔率为 x2, 普通获胜赔率 x2 
        5. 仅允许进行一次分牌。
        6. 若分牌一组 A ，将不能再要牌。
        7. 每组手牌的前两张牌，您可以押双倍。
        8. 分牌后，您可以押双倍。
        9. 庄家需加牌直至超过或等于 17 点。
        10. 庄家手牌达 17 后停止要牌。
        11. 最大押注限制适用于整回合游戏，这意味着某些操作（分牌／加倍）可能在这种情况下不可用。
    `.trim().replace(/ *\n */g, '\n'), 
    ruleDesc01: '获得的牌点数尽量接近且不超过21点，并击败庄家的点数即为赢。',
    // ruleDesc02: '您可以选择要更多的牌或者不再要牌并保留当前手牌。',
    // ruleDesc03: '通过点击＂Double＂，您的押注将会变成双倍，并同时向庄家多要一张牌至手牌。',
    // ruleDesc04: '当您获得两张相同值的牌时，可以点击＂Split＂进行分牌，押注额变成双倍的同时，您可以继续游戏并同时玩两组手牌。',
    // ruleDesc05: '保险仅适用于庄家发给自己的第一张牌为 A 时，保险费用是您押注额的一半。',
    // ruleDesc06: '胜利将属于更接近 21 点的玩家。 玩家和庄家的手牌合计为同值时不计输赢并称为＂push＂。',
    bust: '爆牌',
    // ↓ 这些是 pro 模式弹出窗口中的内容  
    tryNew21Title01: '尝试 21 点全新 PRO Mode 可押两个边注',
    tryNew21Title02: '押注您的底注后才能够添加边注到您的游戏回合。', 
    secondtion01Desc: '完美对子是一种边注，玩家发到的前两张牌组成对子，其中三种不同类型的对子将以不同的赔率支付',
    secondtion02Title: '21+3',
    secondtion02Desc: '于 21+3 边注游戏时，您押注手中的前两张牌和庄家面朝上的牌可能合为三张扑克牌组合。',
};


// 👇自动模式弹出的窗口的内容
const AutoModeRemeder = {
    AutoModeBigTitle: '自动投注策略说明',
    AutoModeTitle: '设置好参数，系统将自动为您下注。',
    AutoModeSection1: '参数说明',
    // ↑ 大小标题 
    // ↓ 以上是对自动模式弹出的输入面板的输入框做说明 
    NumberOfBetsDescription: '设置自动模式的总投注次数。',
    StopOnProfitDescription: '达到盈利目标后停止自动模式。',
    StopOnLossDescription: '达到亏损金额后停止自动模式。',
    MaxBetAmountDescription: '设定单次最大投注金额。',
    OnWinDescription: '重置为赢局后重置投注金额为初始投注金额，加注为赢局后增加投注金额',
    OnLossDescription: '重置为输局后重置投注金额为初始投注金额，加注为输局后增加投注金额',
};

// 👇Fairness 公平性相关信息
const Fairness = {
    Fainess: '公平性',
    FainessContent:
        '一个基于SHA256算法的可证明公平系统，其中包括一个随机数字=随机中奖数字和服务器的初始数字的组合。每一轮都有自己的哈希，由为每次投注生成的独特的随机赢数组成。',
    Check: '公平性校验',
    HowItWorks: '它是如何工作的',
    PreviousRoundsHistory: '历史记录',
    HashRound: '哈希值',
    RandomSeed: '随机种子',
    RoundSeed: '回合种子', // wavesGame 
    FainessMobileContent: '本游戏使用SHA256算法确保游戏的公平性，保证游戏的开奖结果都是随机且不可被操控的。',
    MobileHashRound: '当前哈希值',
    FairnessPrinciple: '公平性原理',
    gameName: '游戏名称',
    PrincipleContent: '游戏使用与比特币相同的SHA256技术确保游戏的公平性。',
    PrincipleContentBefore: '1.下注前，你可以点击“公平性”弹出窗口中的当前哈希值，这个哈希值就像一把锁，它是由一个随机种子生成的，而这个随机种子就是钥匙。也就是说，一旦哈希值（锁）公布了，开奖结果（钥匙）就已经确定且不可更改，这样确保了游戏的公平性。',
    PrincipleContentAfter: '2.下注后，你可以复制随机种子（钥匙)，前往第三方页面生成哈希值(锁)，检查这个哈希值（锁）是否与之前的哈希值（锁）一致。',
};

const GameDetails = {
    BetDetails: '投注详情',
    By: 'By',
    BetCorgi: `${sSiteName}`,
    Player: '玩家',
    Date: '日期',
    BetId: '投注ID',
    PlayGame: '玩游戏',
    CheckFairness: '检查公平性',
    CopyLink: '复制链接',
    CopyMessageTitle: '已复制',
    CopyMessage: '链接已複製',
    UserProfile: '用户资料',
};

const roundDetails = {
    roundDetail: '回合详情',
    RoundID: '回合ID',
    Result: '结果',
    RandomSeed: '随机种子',
};

// 游戏规则
const gameRules = {
    plinkoRule1: '下注后小球掉落，根据小球最终落点的不同位置确定奖金倍数。',
    limboRule1: '预测飞行距离，如果飞行超过预测距离则为赢。',
    coinflipRule1: '选择正面或反面，如果结果与选择一致即为赢。',
    corgiwildRule1: '旋转转轴并匹配相同图案以赢取奖金。',
    corgiwildPaylinesRule: '幸运柯基有一条活跃的支付线',
    corgiwildPayTableRule: '赢分以当前钱包有效资产作为倍率基础',
    any1: '任何 1',
    any2: '任何 2',
    any3: '任何 3',
    wild: 'WILD符号',
    corgiwildPayTableDesc1: '可替代任何符号，赢分成倍增加。',
    corgiwildPayTableDesc2: 'Corgi 们被混在了一起',
    startPlaying: '开始玩',
    circleRule1: '下注不同的颜色，根据最终轮子停留的颜色赢取相应倍数的奖金。',
    tripleRule1: '选择3个方格并下注，刮出3个中奖区的组合赢取相应倍数的奖金。',
};
const UserProfile = {
    UserProfile: '用户资料',
    Activity: '活动',
    Statistics: '统计',
    LeaveATip: '留言',
    TopPlayedGames: '最受欢迎的游戏',
    TournamentsAndBattlesReward: '比赛和战斗奖励',
    TotalBets: '总投注',
    EarnedStaking: '已赚取的质押',
    TotalWagered: '总押注',
    TotalTips: '总留言',
    TotalRains: '总雨点',
    TotalCoindrops: '总金币掉落',
    Wagered: '押注',
    ChatActivityDetails: '聊天活动详情',
    DaysOnThePlatform: '平台上的天数',
    TotalMessages: '总留言',
    LikesReceived: '收到的赞',
    Coindrops: '金币掉落',
    Rains: '雨点',
    CryptoFutures: '加密货币期货',
    TotalWin: '合计赢分'
};

// 游戏右下角的几个控制按钮
const gameSettingBar = {
    Animate: '动画',
    Fast: '快速',
    Statistics: '统计',
    Rules: '规则',
    Settings: '设置',
};

// 游戏名
const gameNames = {
    Dice: '幸运骰子',
    SpaceDice: '高倍骰子',
    Limbo: '凌波跳跃',
    Plinko: '弹珠',
    CoinFlip: '抛硬币',
    Keno: '刮刮乐',
    Crash: '极限飞行',
    Mines: '扫雷',
    Ring: '幸运环',
    Cryptos: '币币摇奖',
    Tower: '逃避恶魔',
    HiLo: '高低竞猜',
    Stairs: '柯基避石',
    Circle: '转运圈',
    Triple: '星际探险',
    Roulette: '轮盘',
    Blackjack: '21点',
    RedPacket: '红包扫雷',
    Niuniu: '百人牛牛',
    Zhajinhua: '炸金花',
    Jisuzhajinhua: '极速炸金花',
    BetCorgiOriginals: 'BetCorgi原创',
    // -- ↓ corgi 系列  -------------------------- 
    Futures: '看涨跌',
    CorgiWild: '幸运柯基',
    Pharaoh: '金字塔',
    CorgiPharaoh: '金字塔',
};

const plinkoI18n = {
    winAmount: '赢分',
    chance: '机会',
    risk: '难度',
    rows: '行数',
    maxPayout: '最大中奖金额'
};

const limboI18n = {
    target: '目标倍率',
};

const coinflipI18n = {
    betHead: '押头',
    betTail: '押尾',
    bet: '押注',
    instant: '单局',
    multiply: '多局',
    profit: '收益',
    series: '局数', // 旧名：系列 
    multiplier: '倍数',
    win: '赢分',
    lose: '输分',
    cashout: '返现',
    firstSide: '第一面'
};

// 用于游戏规则弹出窗口
const gamePlayingRule = {
    howToPlay: '怎么玩',
    rules: '规则',
    payTable: '赔付表',
    payLines: '中奖线',
    Limits: '限制',
    howDoesGameStart: '游戏如何开始',
    payouts: '赔付表',
    payoutsName: '名字',
    payoutsValue: '赔率',
};

const circleI18n = {
    hash: '哈希',
    random: '随机',
    placeBet: '押注',
    showResult: '显示结果',
    stopBet: '停止押注',
    nextRound: '正在准备下轮游戏',
    autoBet: '自动',
    startAuto: '开始自动',
    stopAuto: '停止自动',
    red: '红色',
    gray: '灰色',
    yellow: '黄色',
    green: '绿色',
    myBet: '我的押注',
    winner: '赢家',
    otherJackpots: '其余Jackpot',
    betAmountTips: '余额不足，自动投注已关停'
};


const tripleI18n = {
    autoPick: '机选',
    clearPick: '清除',
};



// ↓ 分类不明，暂时集合在此，慢慢分类
const noClear = {
    Casino: '赌场',
    Favorites: '收藏夹',
    Recent: '最近',
    Battle: '战斗',
    VampireOriginals: '吸血鬼原创',
    Multiplier: '赔率', // 旧版：乘数 
    ProfitOnWin: '奖金', // 旧版：赢利 
    Chancetowin: '胜率', // 旧版：赢的机会
    Menu: '菜单',
    Search: '搜索',
    Contests: '竞赛',
    Chat: '聊天',
    Game: '游戏',
    Time: '时间',
    Payout: '中奖金额',
    PricePool: '奖池',
    MyBFG: '我的BFG',
    AUCTIONBFG: '拍卖BFG',
    Rating: '评分',
    GameRules: '游戏规则',
    Next: '下一个',
    History: '历史',
    AllPlayers: '所有玩家',
    MaxPayout: '最大中奖金额',
    VIPUser: 'VIP用户',
    LiveChart: '实时图表',
    Battles: '竞猜',
    All: '全部',
    Profit: '利润',
    Prize: '奖赏',
    Wagered: '投注',
    Wins: '胜利',
    Losses: '失败',
    FinishIn: '完成于',
    YourPrice: '您的价格',
    Note: '注意！',
    DonNotshowThisAgain: '不再显示',
    Continue: '继续',
    Noinformation: '没有信息',
    Tournaments: '锦标赛',
    Price: '价格',
    Date: '日期',
    BattleName: '战斗名称',
    Place: '地点',
    Detail: '详情',
    Years: '年',
    Months: '月',
    Days: '天',
    CashOut: '返现',
    Copied: '已复制',
    Create: '创建',
    Cancel: '取消',
    OK: '确认',
    AreYouSure: '您确定?',
    Save: '保存',
    No: '否',
    Accept: '接受',
    ExitToLobby: '离开至游戏大厅',
    ID: 'ID',
    RoundId: '回合 ID',
    payout: '分发',
    winningAmount: '中奖金额',
    Congratulations: '恭喜!',
    youWin: '你赢了!',
    Type: '类型',
    State: '状态',
    Redeemed: '已兑换',
    Redeeming: '兑换中',
    StonesNumber: '石头数量',
    FastMode: '快速模式',
    FastModeNitify: '快速模式仅适用自动模式',
    FastModeDisabled: '游戏中禁止切换模式',
};

const liveChatI18n = {
    chatWagered: '总押',
    chatWin: '赢局',
    chatLoses: '输局',
}

// ↓ 在上方导航中弹出的用户菜单
const userMenuInHeader = {
    MyProfile: '我的档案',
    Account: '账户',
    TransactionHistory: '交易历史',
    GameHistory: '游戏历史',
    Sessions: '会话',
    Vault: '保险库',
    Verification: '验证',
};

// ↓用户 session 管理页使用 
const sessionPage = {
    statusActive: '活跃中',
    statusCurrent: '当前',
    date: '日期',
    browser: '浏览器',
};


// ↓ 公共的，多处使用的内容
const commonInfo = {
    Animation: '动画', 
    error: '错误', // ERROR
    info: '信息',
    tips: '提示',
    success: '成功',
    coefficient: '倍数',
    // ↓ 用于弹出的一些消息内容 
    ...{
        hasLoadedLastRound: '已经加载上局游戏',
        newTabGaming: '您已在新的页面中开启当前游戏，当前页已失效。',
        noBacking: '禁止从首页返回。',
        currencyChangedFailed: '币种切换未成功',
        currencyChangedTo: '币种已经切换为：',
        currencyChangedDesc: '你已经在其它页切换了币种，本页币种已经同步变更。游戏的自动下注模式也会被关停（若有）',
        userOffLineTitle: '账号已下线',
        userOffLineDesc: '登录失效，请重新登录',
        badNetwork: '网络状况异常，请检查你的网络链接，或刷新页面',
        wsConnecting: '网络不稳定，正在尝试重新连接 {percentage}%',
        wsRestored: '网络已恢复',
        networkInstability: '网络不稳定',
        attemptingReconnect: '正在尝试重新连接',
        tokenNoValid: '登录状态已过期或失效，请重新登录。',
        requestTimeout: '网络请求超时 {info}', // 传入接口地址，或其它
        requestError: '请求异常',
        locked: '账号已冻结，请联系客服',
    },
    ...{ // 主要用于按钮 
        goBack: '返回',
        refresh: '刷新',
        close: '关闭',
        confirm: '确定',
        confirmBtn: '确定',
        goHomePage: '回首页',
        restRound: '剩局',
    },
    // ↓ 用于在【信息页】显示的一些内容 
    ...{
        notLoggedIn: '未登录', // 用于未登录页面
        logInFailed: '登录未成功',
        connectionFailed: 'Websocket 链接超时，请检查网络状况', 
        pageNotFound: '您要访问的页面不存在',
    },
    ...{ // 下注时提示金额不正确等提示
        noBlance: '余额不足，无法下注',
        lackOfBlance: '余额不足，自动模式已停止',
        amountTooLess: '请输入正确的下注金额，当前币种下注最小值为 {min}',
        amountTooMuch: '请输入正确的下注金额，当前币种下注最大值为 {max}',
        payoutOverLimit: '注意：赔付上限是 {limit}', // limit 应传入数字+单位 
    },
    ...{ // 风险等级 
        riskLow: '低',
        riskMedium: '中',
        riskMediumHigh: '中高',
        riskHigh: '高',
    },
    userId: '用户ID',
    userName: '用户名',
};

const amountTips = {
    'noMoneyPleaseCharge': '余额不足，请充值', 
    'reachedLowerLimit': '已到达投注金最小值', 
    'reachedUpperLimit': '已到达投注金额最大值', 
    'reachedUserBalance': '已到达用户余额',
}

// ↓ 将国际化信息在上方分类，后再注入到下方，以使分类清晰
export default {
    error: commonInfo.error, // 本应调用 t.commonInfo.error 但多处在调用 t.error 和 $t('error')，所以补充这项，用于容错
    ...gameControl,
    ...GameSpaceDice,
    ...history,
    ...AutoModeRemeder,
    ...Fairness,
    ...gameRules,
    ...gameSettingBar,
    ...gameNames,
    ...plinkoI18n,
    ...limboI18n,
    ...coinflipI18n,
    ...noClear,
    ...gamePlayingRule,
    ...circleI18n,
    ...tripleI18n,
    ...liveChatI18n,
    ...roundDetails,
    GameStairs,
    GameTower,
    GameCryptos,
    GameRing,
    UserProfile,
    GameDice,
    GameDetails,
    GameBlackJack,
    ShareBtn,
    menuAndBtn,
    commonInfo,
    userMenuInHeader,
    sessionPage,
    gameTitle,
    amountTips,
};
